import React from 'react'
import "./InfoBox.css";
import {Card, CardContent, Typography} from '@material-ui/core';
import numeral from "numeral";

function InfoBox(props) {
    return (
            <Card onClick={props.onClick} className={`infoBox ${props.active && "border"} ${props.isRed && "danger" }`}>
                <CardContent className="cardContent">
                    <Typography className="title" color="textSecondary"><strong>{props.title}</strong></Typography>
                    <h2 className="cases">{numeral(props.cases).format("0,0")}</h2>
                    <Typography className="total" color="textSecondary">{numeral(props.total).format("0,0")} Total</Typography>
                </CardContent>
            </Card>
    )
}

export default InfoBox
